export default "__VITE_ASSET__5729f4d4__"